import { render, staticRenderFns } from "./SnapShotComponent.vue?vue&type=template&id=32e8591d&scoped=true&"
import script from "./SnapShotComponent.vue?vue&type=script&lang=js&"
export * from "./SnapShotComponent.vue?vue&type=script&lang=js&"
import style0 from "./SnapShotComponent.vue?vue&type=style&index=0&id=32e8591d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e8591d",
  null
  
)

export default component.exports